import { centerAligned } from '@medly-components/utils';
import styled from 'styled-components';
import Header from '../Header';

export const HeaderStyled = styled(Header)`
    gap: 0;
    padding: 0;
    flex-direction: column;
    align-items: stretch;
`;

export const TitleAndActionsWrapper = styled.div<{ withBottomMargin: boolean }>`
    display: flex;
    gap: 1.2rem;
    flex-direction: column;
    max-width: calc(100% - 4.8rem);
    box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.grey[400]};
    padding: 1.6rem 2.4rem ${({ withBottomMargin }) => (withBottomMargin ? '1.6rem' : '0')};

    h2 {
        min-width: fit-content;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        max-width: calc(100% - 8rem);
        padding: 0.8rem 4rem ${({ withBottomMargin }) => (withBottomMargin ? '1.6rem' : '0')};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        flex-direction: row;
    }
`;

export const ActionsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
`;

export const HeaderTitleWrapper = styled.div`
    ${centerAligned('inline-flex')}
    gap: 0.8rem;
    color: ${({ theme }) => theme.colors.silverGrey[500]};
`;
